module.exports = __webpack_public_path__ + "static/media/breadcrumb.4bc36f0a.jpg";